import moment from 'moment'
import { uploadFileToQiniu } from './qiniuUpload'

const IMGPATH = '/default/'

export function uploadPath (path, file) {
  return path + `${moment().format('YYYYMMDD')}/${file.name.split('.')[0]}-${file.uid || '1'}.${file.type.split('/')[1]}`
}

// 转换二进制（富文本等场景可能仍会用到）
export function toBlob (urlData) {
  const base64 = urlData.split(',')[1]
  const fileType = urlData.split(';').shift().split(':').pop()
  let bytes = window.atob(base64)
  let n = bytes.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bytes.charCodeAt(n)
  }
  return new Blob([u8arr], { type: fileType })
}

/** 图片上传至七牛（保留原方法名，避免各页面改动 import） */
export function UploadIMGToOss (file) {
  const originFileObj = file && file.originFileObj ? file.originFileObj : file
  const key = uploadPath(IMGPATH, originFileObj)
  return uploadFileToQiniu(originFileObj, key)
}
